import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "chart-container" }
const _hoisted_2 = { class: "chart-row" }
const _hoisted_3 = { class: "chart-wrapper" }
const _hoisted_4 = { class: "scrollable-chart-container" }
const _hoisted_5 = { class: "chart-inner" }
const _hoisted_6 = { class: "pt-4" }
const _hoisted_7 = { class: "analysis-info" }
const _hoisted_8 = { class: "analysis-date" }
const _hoisted_9 = { class: "analysis-details" }
const _hoisted_10 = {
  key: 0,
  class: "card flex justify-center p-5",
  style: {"width":"100%","background-color":"none","border":"none","box-shadow":"none"}
}
const _hoisted_11 = { class: "row gy-2 overflow-hidden pt-2" }
const _hoisted_12 = { class: "col-12" }
const _hoisted_13 = { class: "form-floating mb-3" }
const _hoisted_14 = { class: "col-12" }
const _hoisted_15 = { class: "form-floating mb-3" }
const _hoisted_16 = { class: "col-12" }
const _hoisted_17 = { class: "form-floating mb-3" }
const _hoisted_18 = { class: "col-12" }
const _hoisted_19 = { class: "form-floating mb-3" }
const _hoisted_20 = { class: "col-12" }
const _hoisted_21 = { class: "form-floating mb-3" }
const _hoisted_22 = { class: "d-grid px-2 py-3 py-md-5" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Toast = _resolveComponent("Toast")!
  const _component_Chart = _resolveComponent("Chart")!
  const _component_Column = _resolveComponent("Column")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_ProgressSpinner = _resolveComponent("ProgressSpinner")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_FloatLabel = _resolveComponent("FloatLabel")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createElementBlock("div", {
    class: "page-container",
    onTouchstart: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.handleTouchStart && _ctx.handleTouchStart(...args))),
    onTouchend: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.handleTouchEnd && _ctx.handleTouchEnd(...args)))
  }, [
    _createVNode(_component_Toast, { position: "bottom-center" }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_Chart, {
                type: "line",
                data: _ctx.chartData,
                options: _ctx.chartOptions,
                height: "200px",
                class: "chart"
              }, null, 8, ["data", "options"])
            ])
          ])
        ])
      ]),
      _cache[11] || (_cache[11] = _createStaticVNode("<div class=\"legend-title\"><div class=\"legend-item\"><span class=\"legend-circle\" style=\"background-color:#ff6384;\"></span> ЛПНП </div><div class=\"legend-item\"><span class=\"legend-circle\" style=\"background-color:#36a2eb;\"></span> ЛПВП </div><div class=\"legend-item\"><span class=\"legend-circle\" style=\"background-color:#ffce56;\"></span> ТГ </div><div class=\"legend-item\"><span class=\"legend-circle\" style=\"background-color:#4bc0c0;\"></span> ОХС </div></div>", 1))
    ]),
    _cache[21] || (_cache[21] = _createElementVNode("div", {
      class: "ps-2 pe-2 pe-0 py-2 mt-2 blocktext",
      style: {"border-left":"10px solid #ffce56"}
    }, " Несмотря на положительную динамику, уровень ЛПНП попрежнему превышает целевые значения. Необходима консультация врача. ", -1)),
    _createElementVNode("div", _hoisted_6, [
      _createVNode(_component_DataTable, {
        value: _ctx.analyses,
        tableStyle: "min-width: 100%",
        class: "analysis-table",
        showHeader: false,
        showGridlines: false
      }, {
        default: _withCtx(() => [
          _cache[13] || (_cache[13] = _createElementVNode("div", {
            style: {"width":"80%"},
            class: "ps-2"
          }, null, -1)),
          _createVNode(_component_Column, { header: "История показателей" }, {
            body: _withCtx(({ data }) => [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, _toDisplayString(data.date), 1),
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("span", null, "ОХС: " + _toDisplayString(data.ohs), 1),
                  _createElementVNode("span", null, "ТГ: " + _toDisplayString(data.tg), 1),
                  _createElementVNode("span", null, "ЛПВП: " + _toDisplayString(data.hdl), 1),
                  _createElementVNode("span", null, "ЛПНП: " + _toDisplayString(data.ldl), 1)
                ])
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_Column, { class: "w-24 !text-end" }, {
            body: _withCtx(() => [
              _createElementVNode("div", {
                class: "expand-icon",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.viewresult = true))
              }, _cache[12] || (_cache[12] = [
                _createElementVNode("i", { class: "pi pi-chevron-right" }, null, -1)
              ]))
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["value"]),
      (_ctx.isLoading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
            _createVNode(_component_ProgressSpinner, {
              style: {"width":"50px","height":"50px","border":"none","background-color":"none"},
              strokeWidth: "1",
              fill: "transparent",
              animationDuration: ".5s",
              "aria-label": "Custom ProgressSpinner"
            })
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("button", {
      class: "floating-button",
      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.visible = true))
    }, _cache[14] || (_cache[14] = [
      _createElementVNode("i", { class: "pi pi-plus" }, null, -1)
    ])),
    _cache[22] || (_cache[22] = _createElementVNode("div", { style: {"margin-bottom":"50px"} }, null, -1)),
    _createVNode(_component_Dialog, {
      visible: _ctx.visible,
      "onUpdate:visible": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.visible) = $event)),
      modal: "",
      header: "Добавить запись",
      style: { width: '50vw' },
      breakpoints: { '1199px': '75vw', '575px': '90vw' }
    }, {
      default: _withCtx(() => [
        _createElementVNode("form", {
          onSubmit: _cache[6] || (_cache[6] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleAddLipids && _ctx.handleAddLipids(...args)), ["prevent"]))
        }, [
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("div", _hoisted_13, [
                _createVNode(_component_FloatLabel, { variant: "on" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_InputText, {
                      id: "fohs",
                      class: "w-100",
                      modelValue: _ctx.lipids.total_cholesterol,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.lipids.total_cholesterol) = $event))
                    }, null, 8, ["modelValue"]),
                    _cache[15] || (_cache[15] = _createElementVNode("label", { for: "fohs" }, "Общий холестерин (ммоль/л)", -1))
                  ]),
                  _: 1
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("div", _hoisted_15, [
                _createVNode(_component_FloatLabel, { variant: "on" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_InputText, {
                      id: "last_name",
                      class: "w-100",
                      modelValue: _ctx.lipids.triglycerides,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.lipids.triglycerides) = $event))
                    }, null, 8, ["modelValue"]),
                    _cache[16] || (_cache[16] = _createElementVNode("label", { for: "last_name" }, "Триглицериды (ммоль/л)", -1))
                  ]),
                  _: 1
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("div", _hoisted_17, [
                _createVNode(_component_FloatLabel, { variant: "on" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_InputText, {
                      id: "last_name",
                      class: "w-100",
                      modelValue: _ctx.lipids.hdl,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.lipids.hdl) = $event))
                    }, null, 8, ["modelValue"]),
                    _cache[17] || (_cache[17] = _createElementVNode("label", { for: "last_name" }, "ЛПВП (ммоль/л)", -1))
                  ]),
                  _: 1
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_18, [
              _createElementVNode("div", _hoisted_19, [
                _createVNode(_component_FloatLabel, { variant: "on" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_InputText, {
                      id: "last_name",
                      class: "w-100",
                      modelValue: _ctx.lipids.ldl,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.lipids.ldl) = $event))
                    }, null, 8, ["modelValue"]),
                    _cache[18] || (_cache[18] = _createElementVNode("label", { for: "last_name" }, "ЛПНП (ммоль/л)", -1))
                  ]),
                  _: 1
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_20, [
              _createElementVNode("div", _hoisted_21, [
                _createVNode(_component_FloatLabel, { variant: "on" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_InputText, {
                      id: "last_name",
                      class: "w-100"
                    }),
                    _cache[19] || (_cache[19] = _createElementVNode("label", { for: "last_name" }, "Липопротеин(а) (мг/дл)", -1))
                  ]),
                  _: 1
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_22, [
              _createVNode(_component_Button, {
                type: "submit",
                label: "Сохранить",
                severity: "success",
                rounded: "",
                raised: ""
              })
            ])
          ])
        ], 32)
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(_component_Dialog, {
      viewresult: _ctx.visible,
      "onUpdate:viewresult": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.visible) = $event)),
      modal: "",
      header: "запись",
      style: { width: '50vw' },
      breakpoints: { '1199px': '75vw', '575px': '90vw' }
    }, {
      default: _withCtx(() => _cache[20] || (_cache[20] = [
        _createTextVNode(" test ")
      ])),
      _: 1
    }, 8, ["viewresult"])
  ], 32))
}